import { FC } from 'react'
import { TextField, Grid } from '@mui/material'

interface IProps {
  value: [string, string]
  onChange: (val: [string, string]) => void
  className: string
  label: string
}

/*
 * Show a pair of TextFields side-by-side. Uses a two-element array to hold the value.
 */
const TextFieldPair: FC<IProps> = ({ value, onChange, className, label }) => {
  // Handle legacy single-line values:
  if (value.constructor !== Array)
    value = ['', (value as unknown as string) || '']

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <TextField
          key="key"
          value={value[0] || ''}
          onChange={(ev) => onChange([ev.target.value, value[1]])}
          className={className}
          label={label}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          key="value"
          value={value[1] || ''}
          onChange={(ev) => onChange([value[0], ev.target.value])}
          className={className}
          label={label}
        />
      </Grid>
    </Grid>
  )
}

export default TextFieldPair
